import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
} from "@/components/ui/sheet.tsx";
import type { HeatmapFocusKey } from "@/bizminer/lib/heatmap/tileColors";
import type { HeatmapScore } from "@/bizminer/lib/heatmap/heatmapTypes";
import KpiDriversCard from "./KpiDriversCard";
import ScorePill from "./ScorePill";

interface HeatmapDrawerProps {
  open: boolean;
  onClose: () => void;
  activeTile: {
    group: { label: string };
    tile: { id: string; label: string };
  } | null;
  activeTileScore: HeatmapScore | null;
  activeStatus: HeatmapFocusKey | "no_data" | null;
  activeGap: string | null;
  kpiQuestions: string[];
  points: Array<number | null>;
  kpiDriverUrls: string[];
  onNavigate: (url: string) => void;
}

export default function HeatmapDrawer({
  open,
  onClose,
  activeTile,
  activeTileScore,
  activeStatus,
  activeGap,
  kpiQuestions,
  points,
  kpiDriverUrls,
  onNavigate,
}: HeatmapDrawerProps) {
  return (
    <Sheet open={open} onOpenChange={(o) => !o && onClose()}>
      <SheetContent className="sm:max-w-md">
        <SheetHeader className="pt-10 pr-10">
          {activeTile ? (
            <div className="flex items-start justify-between gap-3">
              <div>
                <SheetTitle>{activeTile.tile.label}</SheetTitle>
                <SheetDescription>{activeTile.group.label}</SheetDescription>
              </div>
              {activeTileScore &&
                activeStatus &&
                activeStatus !== "no_data" &&
                activeGap && (
                  <ScorePill status={activeStatus} label={activeGap} />
                )}
            </div>
          ) : (
            <>
              <SheetTitle>Pick a tile</SheetTitle>
              <SheetDescription>
                Click a tile in the heatmap to populate this panel.
              </SheetDescription>
            </>
          )}
        </SheetHeader>

        {activeTile && activeTileScore ? (
          <div className="px-4 pb-4">
            <KpiDriversCard
              tileId={activeTile.tile.id}
              kpiQuestions={kpiQuestions}
              points={points}
              kpiDriverUrls={kpiDriverUrls}
              onNavigate={onNavigate}
            />
          </div>
        ) : null}
      </SheetContent>
    </Sheet>
  );
}
